import UIStatusDot from 'UIComponents/tag/UIStatusDot';
import { ApprovalStatus } from 'ui-product-approvals/types';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { jsx as _jsx } from "react/jsx-runtime";
const colorMap = {
  [ApprovalStatus.APPROVAL_PENDING]: 'inReview',
  [ApprovalStatus.APPROVED]: 'published',
  [ApprovalStatus.CANCELLED]: 'cancelled',
  [ApprovalStatus.REJECTED]: 'cancelled'
};
function ApprovalStatusDot() {
  const approval = useApprovalContext();
  if (!approval.data) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIStatusDot, {
    "data-test-id": "approval-status-dot",
    use: colorMap[approval.data.approvalStatus]
  });
}
export default ApprovalStatusDot;